import { isObject } from 'is-what';

export function createProps(value = null) {
    const props = {
        value,
        errors: null
    };
    return props;
}

export function objectDefaultValue(schema, value) {
    const v = {};
    const { properties } = schema;
    if (properties) {
        for (let k in properties) {
            const propSchema = properties[k];
            if (typeof propSchema !== 'boolean') {
                const item = value && value[k];
                v[k] = defaultValue(propSchema, item);
            }
        }
    }
    return v;
}

export function defaultValue(schema, value) {
    if (value === undefined) {
        value = null;
    }
    if (value == null && schema.default !== undefined) {
        value = schema.default;
    }
    switch (schema.type) {
        case 'object':
            return objectDefaultValue(schema, value);
        case 'array':
            return (value || []);
    }
    return value;
}

export function normalizeObject(value, isRoot = true) {
    const obj = {};
    for (const k in value) {
        let v = value[k];
        v = isObject(v) ? normalizeObject(v, false) : v;
        if (!(v === null || v === undefined || v === "not-set")) {
            obj[k] = v;
        }
    }
    return Object.keys(obj).length ? obj : isRoot ? {} : null;
}

export function normalizeValue(value) {
    return isObject(value) ? normalizeObject(value) : value;
}

export function getSchemaComponent(schema, components) {
    if (typeof schema.type !== 'string') {
        throw new Error(`Type "${schema.type}" is not supported`);
    }
    return ((schema.$svelte && schema.$svelte.component) || getComponent(components.fields[schema.type]));
}

export function getSchemaComponentProps(schema, components) {
    if (typeof schema.type !== 'string') {
        throw new Error(`Type "${schema.type}" is not supported`);
    }
    return ((schema.$svelte && schema.$svelte.props) || getComponentProps(components.fields[schema.type]));
}

export function getComponent(container) {
    return Array.isArray(container) ? container[0] : container;
}

export function getComponentProps(container) {
    return Array.isArray(container) ? container[1] : {};
}
